import React from 'react';
var __html = require('./cascade.html.js');

export const Cascade = () => {
  return (
    <iframe
      srcDoc={__html}
      title="CASCADE - Workscope Wireframe"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: '100%',
        height: '100%',
        border: 'none',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        zIndex: 999999
      }}
    >
      Your browser doesn't support iframes
    </iframe>
  );
};
